import { BaseError, ContractFunctionRevertedError } from 'viem'

import { getMorphoErrorMessage } from './morpho-errors.utils'

export function isUserRejectedError(error: Error): boolean {
  const errorName = error.name || ''
  const errorMessage = error.message?.toLowerCase() || ''

  return (
    errorName.includes('UserRejectedRequestError') ||
    errorMessage.includes('user rejected') ||
    errorMessage.includes('user denied') ||
    errorMessage.includes('user cancelled')
  )
}

export function parseViemError(error: unknown) {
  if (!(error instanceof BaseError)) return 'An unknown error occurred'

  if (isUserRejectedError(error)) return 'Cancelled by user'

  const revertError = error.walk(
    e => e instanceof ContractFunctionRevertedError
  ) as ContractFunctionRevertedError | null

  if (revertError) {
    const morphoMessage = getMorphoErrorMessage(revertError.data?.errorName)
    if (morphoMessage) return morphoMessage
    return revertError.reason || revertError.data?.errorName || revertError.shortMessage
  }

  return error.shortMessage || error.message || error.details
}
